import React from 'react';

import { OverflowAvatarStack } from '../OverflowAvatarStack';
import { REPORTING_LINES_USER_CARD_SLOTS_LIMIT } from '../ReportingLinesChart';
import { MissingProfileCard, ReportingLinesUserCard } from '../ReportingLinesUserCard';
import * as Styled from '../styles';
import { type ReportingLinesUser } from '../types';
import { renderReportingLinesUserCard } from './shared';
import { getUsersForLayoutSections } from './util';

interface PeersSectionProps {
	selectedUser: ReportingLinesUser;
	peers: ReportingLinesUser[];
	showAvatarStack: boolean;
	toggleAvatarStack: (firstHiddenAccountIdentifier?: string | null) => void;
}

export const PeersSection = ({
	selectedUser,
	peers,
	showAvatarStack,
	toggleAvatarStack,
}: PeersSectionProps): React.JSX.Element => {
	const { usersForCards, usersForAvatarStack, numMissingProfiles } = getUsersForLayoutSections(
		peers,
		showAvatarStack ? REPORTING_LINES_USER_CARD_SLOTS_LIMIT - 1 : undefined,
	);

	return (
		<Styled.ReportsList testId="peers-section">
			<Styled.ReportsListItem>
				<ReportingLinesUserCard user={selectedUser} selected testId="selected-user-card" />
			</Styled.ReportsListItem>
			{usersForCards.map((user, index) => (
				<Styled.ReportsListItem key={user.accountIdentifier || `peer-${index}`}>
					{renderReportingLinesUserCard(user, `peer-${index}`)}
				</Styled.ReportsListItem>
			))}
			{!usersForAvatarStack && numMissingProfiles > 0 && (
				<Styled.ReportsListItem>
					<MissingProfileCard numMissingProfiles={numMissingProfiles} testId="missing-peers-card" />
				</Styled.ReportsListItem>
			)}
			{usersForAvatarStack && (
				<Styled.ReportsListItem>
					<Styled.ReportsStackContainer>
						<OverflowAvatarStack
							atlassianUsers={usersForAvatarStack}
							numFilteredMissingProfiles={numMissingProfiles}
							onClick={() => toggleAvatarStack(usersForAvatarStack[0]?.accountIdentifier)}
						/>
					</Styled.ReportsStackContainer>
				</Styled.ReportsListItem>
			)}
		</Styled.ReportsList>
	);
};
